export const Actions = {
  achievements: {
    deleteAchievementType: 'DELETE_ACHIEVEMENT_TYPE',
    fetchAllAchievements: 'FETCH_ALL_ACHIEVEMENTS',
    fetchFilteredAchievements: 'FETCH_FILTERED_ACHIEVEMENTS',
    fetchGeekAchievementsCount: 'FETCH_GEEK_ACHIEVEMENTS_COUNT',
    fetchGeekAchievements: 'FETCH_GEEK_ACHIEVEMENTS',
    fetchAchievementsHistory: 'FETCH_ACHIEVEMENTS_HISTORY',
    fetchMoreAchievementsHistory: 'FETCH_MORE_ACHIEVEMENTS_HISTORY',
    fetchAchievementTypes: 'FETCH_ACHIEVEMENT_TYPES',
    resetAchievementTypes: 'RESET_ACHIEVEMENT_TYPES',
    resetGeekAchievements: 'RESET_GEEK_ACHIEVEMENTS',
    updateAchievementTypeIdSharedFilter: 'UPDATE_ACHIEVEMENT_TYPE_ID_SHARED_FILTER',
    addAchievement: 'ADD_ACHIEVEMENT',
    grantAchievement: 'GRANT_ACHIEVEMENT',
    editAchievement: 'EDIT_ACHIEVEMENT',
    deleteAchievement: 'DELETE_ACHIEVEMENT',
    getAchievementTypeBasicInfo: 'GET_ACHIEVEMENT_TYPE_BASIC_INFO',
  },
  activities: {
    fetchAll: 'FETCH_ALL_ACTIVITIES',
    fetchGratifications: 'FETCH_GRATIFICATIONS',
    postActivityRequest: 'POST_ACTIVITY_REQUEST',
    fetchRequests: 'FETCH_REQUESTS',
    fetchMoreRequests: 'FETCH_MORE_REQUESTS',
    fetchGeekActivities: 'FETCH_GEEK_ACTIVITIES',
    fetchRecentActivities: 'FETCH_RECENT_ACTIVITIES',
    postGeekActivityRequests: 'POST_GEEK_ACTIVITY',
    fetchActivitiesHistory: 'FETCH_ACTIVITIES_HISTORY',
    fetchMoreActivitiesHistory: 'FETCH_MORE_ACTIVITIES_HISTORY',
    deleteGeeksActivity: 'DELETE_GEEKS_ACTIVITY',
    fetchWaitingActivityRequests: 'FETCH_WAITING_ACTIVITY_REQUESTS',
    confirmWaitingActivityRequest: 'CONFIRM_WAITING_ACTIVITY_REQUEST',
    rejectWaitingActivityRequest: 'REJECT_WAITING_ACTIVITY_REQUEST',
    redirectWaitingActivityRequest: 'REDIRECT_WAITING_ACTIVITY_REQUEST',
  },
  badges: {
    fetchBadges: 'FETCH_BADGES',
    fetchGeekBadgesCount: 'FETCH_GEEK_BADGES_COUNT',
    fetchGeekBadges: 'FETCH_GEEK_BADGES',
    resetGeekBadgesCount: 'RESET_BADGES_COUNT',
  },
  feedback: {
    post: 'POST_FEEDBACK',
  },
  gCoins: {
    addGCoins: 'ADD_GCOINS',
    fetchAwards: 'FETCH_AWARDS',
    fetchGCoinsHistory: 'FETCH_GCOINS_HISTORY',
    fetchMoreGCoinsHistory: 'FETCH_MORE_GCOINS_HISTORY',
    fetchWaitingRequests: 'FETCH_WAITING_REQUESTS',
    fetchMoreWaitingRequests: 'FETCH_MORE_WAITING_REQUESTS',
    fetchWithdrawalsToExport: 'FETCH_WITHDRAWALS_TO_EXPORT',
    fetchMoreWithdrawalsToExport: 'FETCH_MORE_WITHDRAWALS_TO_EXPORT',
    fetchWaitingWithdrawals: 'FETCH_WAITING_WITHDRAWALS',
    fetchMoreWaitingWithdrawals: 'FETCH_MORE_WAITING_WITHDRAWALS',
    fetchGeekHistory: 'FETCH_GEEK_GCOINS_HISTORY',
    fetchGeeksBalanceEntries: 'FETCH_GEEKS_BALANCE_ENTRIES',
    fetchMoreBalanceEntries: 'FETCH_MORE_BALANCE_ENTRIES',
    fetchAllGeeksBalance: 'FETCH_ALL_GEEKS_BALANCE',
    fetchMoreHistory: 'FETCH_MORE_GEEK_GCOINS_HISTORY',
    fetchGcoinsHistoryTypes: 'FETCH__GCOINS_HISTORY_TYPES',
    withdraw: 'WITHDRAW_GCOINS',
    exchangeGCoins: 'WITHDRAW_GCOINS_BY_ADMIN',
    requestCustomAward: 'REQUEST_CUSTOM_AWARD',
    fetchBalances: 'FETCH_GEEKS_BALANCES',
    acceptWithdrawal: 'ACCEPT_GCOINS_WITHDRAWAL',
    rejectWithdrawal: 'REJECT_GCOINS_WITHDRAWAL',
    fetchWithdrawals: 'FETCH_WITHDRAWALS',
    acceptRequest: 'ACCEPT_GCOINS_REQUEST',
    rejectRequest: 'REJECT_GCOINS_REQUEST',
    confirmRequest: 'CONFIRM_GCOINS_REQUEST',
    orderRequest: 'ORDER_GCOINS_REQUEST',
    handleGCoinsToImportData: 'HANDLE_GCOINS_TO_IMPORT_DATA',
    resetGCoinsToImportData: 'RESET_GCOINS_TO_IMPORT_DATA',
    sendGCoinsToImportData: 'SEND_GCOINS_TO_IMPORT_DATA',
  },
  geek: {
    fetchCurrent: 'FETCH_CURRENT_GEEK',
    fetchGeeks: 'FETCH_ALL_GEEKS',
    fetchAdmins: 'FETCH_ADMINS',
    fetchSuperAdmins: 'FETCH_SUPER_ADMINS',
    fetchGeekBasicInfo: 'FETCH_GEEK_BASIC_INFO',
    getGeekBasicInfo: 'GET_GEEK_BASIC_INFO',
    filter: 'FILTER_GEEKS',
    clearSearch: 'CLEAR_SEARCH',
    fetchCsrfToken: 'FETCH_CSRF_TOKEN',
    setNames: 'SET_GEEK_NAMES',
    setNick: 'SET_GEEK_NICK',
    setAvatar: 'SET_AVATAR',
    fetchGeekJobInfo: 'FETCH_GEEK_JOB_INFO',
    setGeekJobInfo: 'SET_GEEK_JOB_INFO',
    resetGeekInfo: 'RESET_GEEK_INFO',
    resetGeeks: 'RESET_GEEKS',
    updateGeekIdSharedFilter: 'UPDATE_GEEK_ID_SHARED_FILTER',
  },
  guides: {
    fetchAllGuides: 'FETCH_ALL_GUIDES',
    fetchGuideSteps: 'FETCH_GUIDE_STEPS',
    markStepAsFinished: 'MARK_STEP_AS_FINISHED',
    fetchGuideMasterBasicInfo: 'FETCH_GUIDE_MASTER_BASIC_INFO',
    fetchGuideUserBasicInfo: 'FETCH_GUIDE_USER_BASIC_INFO',
  },
  history: {
    fetchLatestAccomplishment: 'FETCH_LATEST_ACCOMPLISHMENT',
    fetchGeekHistory: 'FETCH_GEEK_HISTORY',
    fetchMoreGeekHistory: 'FETCH_MORE_GEEK_HISTORY',
    resetLatestAccomplishment: 'RESET_LATEST_ACCOMPLISHMENT',
  },
  kitchenTv: {
    fetchLeaderboard: 'FETCH_GEEKS_FOR_TV_LEADERBOARD',
    fetchRecentActivities: 'FETCH_RECENT_ACTIVITIES_FOR_TV',
    fetchLatestKudosPhotos: 'FETCH_LATEST_KUDOS_PHOTOS_FOR_TV',
    fetchOpportunities: 'FETCH_OPPORTUNITIES_FOR_TV',
  },
  management: {
    geeksManagement: {
      fetchGeeks: 'FETCH_GEEKS_WITH_STATUS',
      fetchMoreGeeks: 'FETCH_MORE_GEEKS_WITH_STATUS',
      changeGeeksStatus: 'CHANGE_GEEKS_STATUS',
      fetchAccessRequests: 'FETCH_ACCESS_REQUESTS',
      approveAccessRequest: 'APPROVE_ACCESS_REQUEST',
      declineAccessRequest: 'DECLINE_ACCESS_REQUEST',
    },
  },
  news: {
    fetchNews: 'FETCH_NEWS',
    fetchAdminNews: 'FETCH_ADMIN_NEWS',
    fetchMoreNews: 'FETCH_MORE_NEWS',
    fetchMoreAdminNews: 'FETCH_MORE_ADMIN_NEWS',
    deleteNews: 'DELETE_NEWS',
    fetchNewsById: 'FETCH_NEWS_BY_ID',
    addNews: 'ADD_NEWS',
    editNews: 'EDIT_NEWS',
  },
  notifications: {
    fetch: 'FETCH_NOTIFICATIONS',
    markAsRead: 'MARK_AS_READ',
  },
  opportunities: {
    fetchOpportunities: 'FETCH_OPPORTUNITIES',
    fetchMoreOpportunities: 'FETCH_MORE_OPPORTUNITIES',
    fetchNews: 'FETCH_OPPORTUNITIES_NEWS',
    fetchCurrent: 'FETCH_CURRENT',
    changeCandidateStatus: 'CHANGE_OPPORTUNITY_CANDIDATE_STATUS',
    changeMembershipStatus: 'APPLY_TO_OPPORTUNITY',
    approveOpportunity: 'APPROVE_OPPORTUNITY',
    sendMessage: 'SEND_MESSAGE',
    giveFeedback: 'GIVE_OPPORTUNITY_FEEDBACK',
    rejectOpportunity: 'REJECT_OPPORTUNITY',
    launchOpportunity: 'LAUNCH_OPPORTUNITY',
    finalizeOpportunity: 'FINALIZE_OPPORTUNITY',
    fetchFinalizationDraft: 'FETCH_FINALIZATION_DRAFT',
    keepFinalizationDraft: 'KEEP_FINALIZATION_DRAFT',
    editFinalizationDraft: 'EDIT_FINALIZATION_DRAFT',
    deleteOpportunity: 'DELETE_OPPORTUNITY',
    cancelRecruitingOpportunity: 'CANCEL_RECRUITING_OPPORTUNITY',
    cancelOngoingOpportunity: 'CANCEL_ONGOING_OPPORTUNITY',
    fetchDepartments: 'FETCH_DEPARTMENTS',
    fetchLevels: 'FETCH_LEVELS',
    fetchTags: 'FETCH_TAGS',
    fetchPopularTags: 'FETCH_POPULAR_TAGS',
    create: 'CREATE_OPPORTUNITY',
    edit: 'EDIT_OPPORTUNITY',
    fetchGeeksWithRoles: 'FETCH_OPPORTUNITY_GEEKS_WITH_ROLES',
    fetchMoreGeeksWithRoles: 'FETCH_MORE_OPPORTUNITY_GEEKS_WITH_ROLES',
    fetchCandidates: 'FETCH_OPPORTUNITY_PARTICIPANTS',
    filterCandidates: 'FILTER_OPPORTUNITY_PARTICIPANTS',
    addMember: 'ADD_OPPORTUNITY_MEMBER',
    changeGeekRole: 'CHANGE_OPPORTUNITY_GEEK_ROLE',
    fetchCounters: 'FETCH_OPPORTUNITIES_COUNTERS',
    fetchCreators: 'FETCH_OPPORTUNITY_CREATORS',
    fetchIssuers: 'FETCH_OPPORTUNITY_ISSUERS',
    fetchAdmins: 'FETCH_OPPORTUNITY_ADMINS',
    fetchApprovers: 'FETCH_OPPORTUNITY_APPROVERS',
    fetchGeeksCounters: 'FETCH_GEEKS_COUNTERS',
    fetchGeekOpportunitiesCount: 'FETCH_GEEK_OPPORTUNITIES_COUNT',
    fetchReport: 'FETCH_REPORT',
    resetCandidates: 'RESET_CANDIDATES',
    drafts: {
      fetchOpportunitiesDrafts: 'FETCH_OPPORTUNITIES_DRAFTS',
      fetchCurrent: 'FETCH_CURRENT_OPPORTUNITY_DRAFT',
      create: 'CREATE_OPPORTUNITY_DRAFT',
      delete: 'DELETE_OPPORTUNITY_DRAFT',
      edit: 'EDIT_OPPORTUNITY_DRAFT',
    },
  },
  rules: {
    setLargeScreen: 'SET_LARGE_SCREEN',
  },
  scores: {
    fetchGeekGeneralScore: 'FETCH_GEEK_GENERAL_SCORE',
    fetchGeekGeneralPosition: 'FETCH_GEEK_GENERAL_POSITION',
    fetchGeekSkillScores: 'FETCH_GEEK_SKILL_SCORES',
    fetchLeaderboard: 'FETCH_LEADERBOARD',
    fetchMoreLeaderboard: 'FETCH_MORE_LEADERBOARD',
    fetchGeekPersonalBest: 'FETCH_GEEK_PERSONAL_BEST',
    resetGeekGeneralScore: 'RESET_GEEK_GENERAL_SCORE',
    resetGeekSkillScores: 'RESET_GEEK_SKILL_SCORES',
  },
  seasons: {
    fetchCurrentSeason: 'FETCH_CURRENT_SEASON',
    fetchAllSeasons: 'FETCH_ALL_SEASONS',
    addSeason: 'ADD_SEASON',
    editSeason: 'EDIT_SEASON',
  },
  themes: {
    fetchCurrentTheme: 'FETCH_CURRENT_THEME',
  },
  users: {
    fetchCurrentUserStatus: 'FETCH_CURRENT_USER_STATUS',
    fetchAppInsightsInstrumentationKey: 'APPINSIGHTS_INSTRUMENTATIONKEY',
  },
  account: {
    signIn: 'SIGN_IN',
    signOut: 'SIGN_OUT',
    signUp: 'SIGN_UP',
    forgotPassword: 'FORGOT_PASSWORD',
    resetPassword: 'RESET_PASSWORD',
    changePassword: 'CHANGE_PASSWORD',
    requestForChangeEmail: 'CHANGE_EMAIL_REQUEST',
    changeEmail: 'CHANGE_EMAIL',
    confirmEmail: 'CONFIRM_EMAIL',
    confirmNewEmail: 'CONFIRM_NEW_EMAIL',
  },
};
